import React from 'react';
import PropTypes from 'prop-types';

import './ProductQuestionsList.scss';

import ProductQuestionsAndAnswersCard from './ProductQuestionsAndAnswersCard';
import { questionsPropTypes } from './propTypes';

const ProductQuestionsList = ({ questions, pageNumber }) => (
	<div className="ProductQuestionsList">
		<div className="ProductQuestionsList_container">
			{questions.length > 0 ? (
				questions.map((question, index) => (
					<div className="ProductQuestionsList__content" key={question.id}>
						<ProductQuestionsAndAnswersCard
							question={question}
							pageNumber={pageNumber}
							questionPos={index + 1}
						/>
					</div>
				))
			) : (
				<div className="ProductQuestionsList__empty">Be the first to ask a question about this item.</div>
			)}
		</div>
	</div>
);

ProductQuestionsList.propTypes = {
	questions: PropTypes.oneOfType([ PropTypes.shape({}), PropTypes.arrayOf(questionsPropTypes) ]),
	pageNumber: PropTypes.number
};

export default ProductQuestionsList;
